import { Box, Grid } from "@mui/material";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import Loader from "../components/loader";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import { ExerciseRequest } from "../service/model/workout.model";
import SearchBox from "../components/search-box";
import useExercises from "../hooks/use-exercises";
import ExerciseTable from "../features/workout/exercise/components/exercise-table";
import ExerciseForm from "../features/workout/workout-plan/components/exercise-form";
import * as exerciseSlice from "../features/workout/exercise/exercise.slice";
import CreateButton from "../components/create-button";

const Exercises = () => {
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const loggedInUser = loggedInUserDetails?.user;
    const [showExerciseForm, setShowExerciseForm] = useState(false);
    const isLoading = useAppSelector(exerciseSlice.selectIsLoading);

    const [exercises] = useExercises();

    const [name, setName] = useState("");

    const handleSubmit = (data: ExerciseRequest) => {
        loggedInUser && dispatch(exerciseSlice.createExercise({ ...data, })).then(resp => {
            if (resp.meta.requestStatus === 'fulfilled') {
                setShowExerciseForm(false);
            }
        });
    };

    return (
        <div>
            {isLoading &&
                <Loader />
            }
            {exercises &&
                <>
                    <Box sx={{ mb: "12px" }}>
                        <CreateButton variant="contained" onClick={() => setShowExerciseForm(true)} style={{ marginBottom: "12px" }}>Add Exercise</CreateButton>
                    </Box>
                    <Grid container direction="row" style={{ marginTop: '12px', alignItems: 'center' }}>
                        <Grid size={{ xs: 12, lg: 4 }}>
                            <SearchBox placeholder="Search by name" setSearchValue={setName} />
                        </Grid>
                    </Grid>
                    <ExerciseTable exercises={exercises.filter(item => item.name.toLowerCase().includes(name.toLowerCase()))} />
                    {showExerciseForm &&
                        <ExerciseForm exercise={undefined} editable={true} onClose={() => setShowExerciseForm(false)} onSubmit={handleSubmit} />
                    }
                </>
            }
        </div>
    )
}

export default Exercises;